// extracted by mini-css-extract-plugin
export default {"ArrowWrapper":"SpoilerArrow_ArrowWrapper__J68d9","ArrowImg":"SpoilerArrow_ArrowImg__A+Zhz","open":"SpoilerArrow_open__3vk57"};